function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 3h20v20H4V3z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#wanzhuan_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.002 21.937a8.842 8.842 0 003.478-.703 8.865 8.865 0 002.84-1.915 8.863 8.863 0 001.915-2.84 8.838 8.838 0 00.702-3.477c0-1.212-.234-2.371-.703-3.478a8.864 8.864 0 00-1.914-2.84 8.865 8.865 0 00-2.84-1.915 8.838 8.838 0 00-3.478-.702c-1.212 0-2.371.234-3.478.702a8.864 8.864 0 00-2.84 1.915 8.864 8.864 0 00-1.915 2.84 8.838 8.838 0 00-.702 3.478c0 1.403.31 2.73.932 3.979a.733.733 0 01.07.533l-.497 1.857c-.167.624-.022 1.166.435 1.624.458.457 1 .603 1.624.438l1.858-.498a.724.724 0 01.526.064 8.8 8.8 0 003.987.938zm5.47-3.466c-1.511 1.51-3.334 2.266-5.47 2.266a7.58 7.58 0 01-3.435-.803 1.909 1.909 0 00-1.388-.158l-1.855.497a.456.456 0 01-.467-.125.455.455 0 01-.125-.468l.495-1.855a1.885 1.885 0 00-.154-1.378 7.634 7.634 0 01-.806-3.445c0-2.136.755-3.96 2.266-5.47 1.51-1.51 3.333-2.265 5.469-2.265s3.959.755 5.47 2.265c1.51 1.51 2.265 3.334 2.265 5.47 0 2.135-.755 3.959-2.266 5.47z",
  fill: "#6B7280"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.139 14.432c.528-.445.791-.922.791-1.43 0-.509-.263-.986-.791-1.43-.28-.237-.882-.64-1.807-1.209l-.002-.001c-.94-.578-1.578-.938-1.915-1.08-.653-.277-1.2-.28-1.643-.012-.43.26-.694.745-.793 1.455-.052.376-.079 1.135-.079 2.277 0 1.142.027 1.9.079 2.276.1.71.364 1.196.794 1.456.442.268.99.264 1.642-.012.337-.142.975-.502 1.914-1.08l.003-.002c.925-.57 1.527-.972 1.807-1.208zm-.774-1.944c.244.206.365.377.365.514 0 .136-.121.307-.365.513-.234.197-.788.565-1.662 1.103l-.002.002c-.887.545-1.472.878-1.754.997-.275.117-.46.147-.553.09-.104-.063-.18-.261-.226-.595-.045-.32-.068-1.024-.068-2.11 0-1.087.023-1.79.068-2.11.046-.334.122-.533.227-.596.092-.057.276-.026.552.09.282.12.867.452 1.754.998h.002c.874.539 1.428.907 1.662 1.104z",
  fill: "#6B7280",
  opacity: 0.6
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wanzhuan_svg__clip0_200_833"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})));

var SvgWanzhuan = function SvgWanzhuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wanzhuan_svg__clip0_200_833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wanzhuan_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 20,
    height: 20
  }, _ref), _ref2), _ref3);
};

export default SvgWanzhuan;